import React from 'react'
import BaseOperatorForm from './BaseOperatorForm'

export default function CreateOperatorForm(props) {
  return <BaseOperatorForm {...props} locationKey="top_base" locationLabel="ТОП-База"
    createOperator={props.createTopBaseOperator} loadOperators={props.loadOperators} />
}
